import { IMAGES } from "./images"

export const ABOUT_PAGE = {
  title: "درباره مدیزن",

  description: "پلتفرم جامع و هوشمند سلامت برای دریافت نوبت حضوری و مشاوره آنلاین پزشکی ارائه‌دهنده خدمات نوین و یکپارچه درمانی برای تجربه‌ای سریع و مطمئن.",

  history: "آغاز فعالیت در سال ۱۴۰۲ با نوبت‌دهی پزشکی و توسعه مستمر به سوی خدمات یکپارچه درمانی.",
    
  value: "تعهد به شفافیت اطلاعات، حفظ حریم خصوصی و ارزش‌گذاری به زمان کاربران برای انتخابی آگاهانه.",
    
  goal: "تسهیل دسترسی مستقیم به برترین متخصصان و ساده‌سازی مسیر جامع سلامت برای تمامی افراد جامعه.",
    
  moreDesc: "در پلتفرم مدیزن، امکان جست‌وجوی هوشمند متخصصان بر اساس حوزه تخصص، زمان‌های آزاد، موقعیت مکانی و نظرات کاربران برای رزرو نوبت حضوری فراهم شده است. همچنین، بستر مشاوره آنلاین به شما کمک می‌کند تا در سریع‌ترین زمان ممکن، روند تشخیص و درمان خود را آغاز کنید. با هدف تکمیل زنجیره سلامت، به‌زودی خدمات نوین دیگری از جمله «تهیه و ارسال دارو»، «انجام آزمایش در محل» و «نسخه‌نویسی الکترونیک» نیز به پلتفرم افزوده خواهد شد تا تمامی نیازهای درمانی شما به صورت یکپارچه، سریع و قابل‌پیگیری برآورده شود.",

  selectedDoctors: [
    {
      img: IMAGES.about.doctors.doctor1,
      id: 1,
      name: "دکتر نرگس خادمی",
      text: "متخصص زنان و زایمان",
    },
    {
      img: IMAGES.about.doctors.doctor2,
      id: 2,
      name: "دکتر مریم متین",
      text: "فوق‌تخصص غدد",
    },
    {
      img: IMAGES.about.doctors.doctor3,
      id: 3,
      name: "دکتر فرامرز دهخدا",
      text: "متخصص داخلی",
    },
    {
      img: IMAGES.about.doctors.doctor4,
      id: 4,
      name: "دکتر حسام صفرزاده",
      text: "روانپزشک",
    },
    {
      img: IMAGES.about.doctors.doctor5,
      id: 5,
      name: "دکتر محمد نودهی",
      text: "روان‌پزشک",
    },
    {
      img: IMAGES.about.doctors.doctor1,
      id: 6,
      name: "دکتر سمیرا چهروی",
      text: "متخصص اطفال",
    },
    {
      img: IMAGES.about.doctors.doctor2,
      id: 7,
      name: "دکتر مژگان صالحی",
      text: "دکترای داروسازی",
    },
    {
      img: IMAGES.about.doctors.doctor3,
      id: 8,
      name: "دکتر حمیدرضا خادم",
      text: "متخصص ارتوپدی",
    },
    {
      img: IMAGES.about.doctors.doctor4,
      id: 9,
      name: "دکتر فریبرز خانعلی",
      text: "متخصص پوست، مو و زیبایی",
    },
  ],

userReviews: "رضایت و اعتماد کاربران، ارزشمندترین دستاورد پلتفرم مدیزن است. ما همواره در تلاشیم تا با ارائه خدماتی سریع، امن و دردسترس، دغدغه‌های مراجعه به مراکز درمانی را به حداقل برسانیم. در این بخش، گزیده‌ای از تجربیات همراهانی را می‌خوانید که از خدمات نوبت‌دهی، مشاوره آنلاین و سایر امکانات پلتفرم استفاده کرده‌اند. این بازخوردها نه‌تنها چراغ راه ما برای ارتقای مستمر کیفیت خدمات فعلی است، بلکه الهام‌بخش ما در مسیر توسعه‌ی امکانات نوین و یکپارچه‌ی سلامت خواهد بود.",

  comments: [
    {
      id: 1,
      img: IMAGES.about.comments.cm1,
      name: "سهیلا ناصری",
      title: "رزرو نوبت سریع و بی‌دغدغه",
      cm: "دنبال دکتر زنان می‌گشتم و خیلی راحت از بین وقت‌های آزاد، نوبتم رو گرفتم. اصلاً لازم نبود زنگ بزنم، همه‌چیز شفاف بود.",
    },
    {
      id: 2,
      img: IMAGES.about.comments.cm2,
      name: "نگین منتظری",
      title: "کارآمدی بالای مشاوره آنلاین",
      cm: "چون نمی‌تونستم برم دکتر، آنلاین مشاوره گرفتم. دکتر خیلی کامل راهنمایی کرد و دقیقاً فهمیدم باید چکار کنم. خیلی راضی‌ام.",
    },
    {
      id: 3,
      img: IMAGES.about.comments.cm4,
      name: "میلاد حسین‌زاده",
      title: "جامعیت خدمات",
      cm: "اینکه هم پزشک و هم کلینیک توی یه جا هستن، خیلی خوبه. امیدوارم زودتر بخش‌های دیگه هم فعال بشه.",
    },
    {
      id: 4,
      img: IMAGES.about.comments.cm5,
      name: "سالار محمدی",
      title: "رابط کاربری ساده و روان",
      cm: "از اول تا آخرش، همه چیز خیلی ساده طراحی شده و راحت میشه باهاش کار کرد. حتی اگه با اینجور چیزا آشنا نباشین هم مشکلی نیست.",
    },
  ],

  stats: {
    doctors: 220,
    articles: 450,
    specialties: 28,
    users: 12000,
  },
};


export const CONTACT_PAGE = {
    title:'تماس با ما',
    desc:'کاربر گرامی، برای دریافت خدمات پشتیبانی یا برقراری ارتباط با بخش‌های مختلف، از راه‌های زیر با ما در تماس باشید. تیم ما در سریع‌ترین زمان ممکن پاسخگوی شما خواهد بود',
    address:'مازندران، ساری، میدان ساعت، ابتدای مدرس، ساختمان سازمان اقتصاد اسلامی، طبقه3، واحد9',
    phone1:'02171057191',
    phone2:'01133118994',
    email1:'info@medizen.ir',
    email2:'customer@medizen.ir',
    phoneName1:'شماره تماس سراسری:',
    phoneName2:'شماره تماس دفتر ساری:'
}

export const MAIN_PAGE = {
    slider:[
    {
    id:1,
    title:'ویزیت آنلاین پزشکی در سریع‌ترین زمان',
    subtitle:'بی‌معطلی پیگیر سلامتی',
    desc:'با مدیزن دیگر نیازی به انتظار طولانی در مطب‌های پزشکی نیست. تنها با چند کلیک، به بهترین پزشکان متخصص دسترسی پیدا کنید و در کمترین زمان ممکن، مشاوره تخصصی دریافت کنید',
    bg:IMAGES.home.hero.h1,
    txtBtn: 'دسترسی سریع به پزشکان معتبر'
    },
    {
    id:2,
    title:'ویزیت آنلاین پزشکی در سریع‌ترین زمان',
    subtitle:'بی‌معطلی پیگیر سلامتی',
    desc:'با مدیزن دیگر نیازی به انتظار طولانی در مطب‌های پزشکی نیست. تنها با چند کلیک، به بهترین پزشکان متخصص دسترسی پیدا کنید و در کمترین زمان ممکن، مشاوره تخصصی دریافت کنید',
    bg:IMAGES.home.hero.h2,
    txtBtn: 'دسترسی سریع به پزشکان معتبر'
    },
    {
    id:3,
    title:'ویزیت آنلاین پزشکی در سریع‌ترین زمان',
    subtitle:'بی‌معطلی پیگیر سلامتی',
    desc:'با مدیزن دیگر نیازی به انتظار طولانی در مطب‌های پزشکی نیست. تنها با چند کلیک، به بهترین پزشکان متخصص دسترسی پیدا کنید و در کمترین زمان ممکن، مشاوره تخصصی دریافت کنید',
    bg:IMAGES.home.hero.h3,
    txtBtn: 'دسترسی سریع به پزشکان معتبر'
    },

],
    services:{
        desc:'مدیزن با هدف ساده‌تر کردن دسترسی به خدمات پزشکی، مجموعه‌ای کامل از خدمات سلامت را به کاربران ارائه می‌دهد. از نوبت‌دهی آنلاین و مشاوره پزشکی غیرحضوری گرفته تا دسترسی سریع به پزشکان متخصص در حوزه‌های مختلف، همه‌چیز در یک پلتفرم یکپارچه فراهم شده است. کاربران می‌توانند به‌راحتی پزشک موردنظر خود را پیدا کنند، سوابق درمانی خود را مدیریت کنند و بدون اتلاف وقت، خدمات پزشکی موردنیازشان را دریافت کنند.',
    servicesCards:[
    {
    id:1,
    title:'لورم ایپسوم متن ساختگی',
    icon:IMAGES.home.services.icon,
    desc:'چاپگرها و متون بلکه روزنامه و مجله در ستون و سطر آنچنان که لازم است '
    },
    {
    id:2,
    title:'لورم ایپسوم متن ساختگی',
    icon:IMAGES.home.services.icon,
    desc:'چاپگرها و متون بلکه روزنامه و مجله در ستون و سطر آنچنان که لازم است '
    },
    {
    id:3,
    title:'لورم ایپسوم متن ساختگی',
    icon:IMAGES.home.services.icon,
    desc:'چاپگرها و متون بلکه روزنامه و مجله در ستون و سطر آنچنان که لازم است '
    },
    {
    id:4,
    title:'لورم ایپسوم متن ساختگی',
    icon:IMAGES.home.services.icon,
    desc:'چاپگرها و متون بلکه روزنامه و مجله در ستون و سطر آنچنان که لازم است '
    },
    {
    id:5,
    title:'لورم ایپسوم متن ساختگی',
    icon:IMAGES.home.services.icon,
    desc:'چاپگرها و متون بلکه روزنامه و مجله در ستون و سطر آنچنان که لازم است '
    },
    {
    id:6,
    title:'لورم ایپسوم متن ساختگی',
    icon:IMAGES.home.services.icon,
    desc:'چاپگرها و متون بلکه روزنامه و مجله در ستون و سطر آنچنان که لازم است '
    },
    {
    id:7,
    title:'لورم ایپسوم متن ساختگی',
    icon:IMAGES.home.services.icon,
    desc:'چاپگرها و متون بلکه روزنامه و مجله در ستون و سطر آنچنان که لازم است '
    },
    {
    id:8,
    title:'لورم ایپسوم متن ساختگی',
    icon:IMAGES.home.services,
    desc:'چاپگرها و متون بلکه روزنامه و مجله در ستون و سطر آنچنان که لازم است '
    },
   
]
    },
    aboutUs:{
        desc:'مدیزن یک پلتفرم برخط ارائه خدمات پزشکی است که با هدف ساده‌تر کردن دسترسی به خدمات سلامت، تجربه‌ای سریع، مطمئن و هوشمند را برای کاربران فراهم کرده است. ما تلاش می‌کنیم تا افراد بتوانند بدون محدودیت زمانی و مکانی، به خدماتی مانند نوبت‌دهی آنلاین، ویزیت پزشک، مشاوره تخصصی و پیگیری روند درمان دسترسی داشته باشند.',
        moreDesc:'در مدیزن خدمات متنوعی از جمله ویزیت آنلاین، آزمایش در محل، تهیه نسخه، دسترسی به پزشکان متخصص و مدیریت خدمات درمانی در یک بستر یکپارچه ارائه می‌شود. هدف ما این است که با استفاده از فناوری، فرآیند دریافت خدمات پزشکی را ساده‌تر، سریع‌تر و در دسترس‌تر کنیم تا کاربران بتوانند با آرامش بیشتری سلامت خود و خانواده‌شان را مدیریت کنند.',
        img:IMAGES.home.about
    },
    appDownload:{
        desc:'با اپلیکیشن مدیزن می‌توانید به مجموعه‌ای کامل از خدمات پزشکی و سلامت به‌صورت آنلاین و در هر زمان دسترسی داشته باشید. از رزرو نوبت پزشک و ویزیت آنلاین گرفته تا درخواست آزمایش در محل، دریافت نسخه، مشاهده سوابق درمانی و ارتباط آسان با پزشکان متخصص، همه خدمات در یک محیط ساده و کاربردی در اختیار شما قرار دارد تا بتوانید سریع‌تر و راحت‌تر امور درمانی خود را مدیریت کنید.',
    options:[
        'دسترسی سریع به گفتگوی پزشکان',
        'ثبت اطلاعات سلامتی و درمانی',
        'دسترسی سریع تر به اطلاعات پزشکان',
    ],
    img:IMAGES.home.download
    },
    news:{
    title:'',
    cards:[
       {
            img: IMAGES.home.news.news1,
            id: 1,
            user: 'محمدعلی توکلی',
            clock:'1 مرداد 1404',
            title: 'درماتیت سبورئیک چیست؟ + علائم، علت و درمان',
            text:'این بیماری پوستی، باعث ایجاد لکه‌های قرمزی با احساس خارش و پوسته چرب روی پوست می شود و پوسته‌ پوسته‌هایی سفید یا زرد بر روی پوست شما ایجاد می‌کند و شباهت زیادی به شوره سر دارد',
        },
        {
            img: IMAGES.home.news.news2,
            id: 2,
            user: 'محمدعلی توکلی',
            clock:'1 مرداد 1404',
            title: 'درماتیت سبورئیک چیست؟ + علائم، علت و درمان',
            text:'این بیماری پوستی، باعث ایجاد لکه‌های قرمزی با احساس خارش و پوسته چرب روی پوست می شود و پوسته‌ پوسته‌هایی سفید یا زرد بر روی پوست شما ایجاد می‌کند و شباهت زیادی به شوره سر دارد',
        },
        {
            img: IMAGES.home.news.news3,
            id: 3,
            user: 'محمدعلی توکلی',
            clock:'1 مرداد 1404',
            title: 'درماتیت سبورئیک چیست؟ + علائم، علت و درمان',
            text:'این بیماری پوستی، باعث ایجاد لکه‌های قرمزی با احساس خارش و پوسته چرب روی پوست می شود و پوسته‌ پوسته‌هایی سفید یا زرد بر روی پوست شما ایجاد می‌کند و شباهت زیادی به شوره سر دارد',
        },
        {
            img: IMAGES.home.news.news4,
            id: 4,
            user: 'محمدعلی توکلی',
            clock:'1 مرداد 1404',
            title: 'درماتیت سبورئیک چیست؟ + علائم، علت و درمان',
            text:'این بیماری پوستی، باعث ایجاد لکه‌های قرمزی با احساس خارش و پوسته چرب روی پوست می شود و پوسته‌ پوسته‌هایی سفید یا زرد بر روی پوست شما ایجاد می‌کند و شباهت زیادی به شوره سر دارد',
        },
        {
            img: IMAGES.home.news.news5,
            id: 5,
            user: 'محمدعلی توکلی',
            clock:'1 مرداد 1404',
            title: 'درماتیت سبورئیک چیست؟ + علائم، علت و درمان',
            text:'این بیماری پوستی، باعث ایجاد لکه‌های قرمزی با احساس خارش و پوسته چرب روی پوست می شود و پوسته‌ پوسته‌هایی سفید یا زرد بر روی پوست شما ایجاد می‌کند و شباهت زیادی به شوره سر دارد',
        },
        {
            img: IMAGES.home.news.news6,
            id: 6,
            user: 'محمدعلی توکلی',
            clock:'1 مرداد 1404',
            title: 'درماتیت سبورئیک چیست؟ + علائم، علت و درمان',
            text:'این بیماری پوستی، باعث ایجاد لکه‌های قرمزی با احساس خارش و پوسته چرب روی پوست می شود و پوسته‌ پوسته‌هایی سفید یا زرد بر روی پوست شما ایجاد می‌کند و شباهت زیادی به شوره سر دارد',
        },
        {
            img: IMAGES.home.news.news7,
            id: 7,
            user: 'محمدعلی توکلی',
            clock:'1 مرداد 1404',
            title: 'درماتیت سبورئیک چیست؟ + علائم، علت و درمان',
            text:'این بیماری پوستی، باعث ایجاد لکه‌های قرمزی با احساس خارش و پوسته چرب روی پوست می شود و پوسته‌ پوسته‌هایی سفید یا زرد بر روی پوست شما ایجاد می‌کند و شباهت زیادی به شوره سر دارد',
        },

    ]
    },
    social:{
        title:'ما را در شبکه‌های اجتماعی دنبال کنید',
        desc:'برای اطلاع از جدیدترین خدمات، اخبار و نکات سلامتی، مدیزن را در شبکه‌های اجتماعی دنبال کنید.',
        img:IMAGES.home.social
    },
    questionsSection:{
        title:'',
        questions:[
            {
                id:1,
                question:'لورم ایپسوم متن ساختگی باتولید سادگی نامفهوم ازصنعت چاپ و با استفاده از طراحان گرافیک است؟',
                answer:'چاپگرها و متون بلکه روزنامه و مجله در ستون و سطر آنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزار های کاربردی می باشد. کتاب زیادی در شصت و سه در صد گذشته، حال و آینده شناخت'
            },
            {
                id:2,
                question:'لورم ایپسوم متن ساختگی باتولید سادگی نامفهوم ازصنعت چاپ و با استفاده از طراحان گرافیک است؟',
                answer:'چاپگرها و متون بلکه روزنامه و مجله در ستون و سطر آنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزار های کاربردی می باشد. کتاب زیادی در شصت و سه در صد گذشته، حال و آینده شناخت'
            },
            {
                id:3,
                question:'لورم ایپسوم متن ساختگی باتولید سادگی نامفهوم ازصنعت چاپ و با استفاده از طراحان گرافیک است؟',
                answer:'چاپگرها و متون بلکه روزنامه و مجله در ستون و سطر آنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزار های کاربردی می باشد. کتاب زیادی در شصت و سه در صد گذشته، حال و آینده شناخت'
            },
            {
                id:4,
                question:'لورم ایپسوم متن ساختگی باتولید سادگی نامفهوم ازصنعت چاپ و با استفاده از طراحان گرافیک است؟',
                answer:'چاپگرها و متون بلکه روزنامه و مجله در ستون و سطر آنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزار های کاربردی می باشد. کتاب زیادی در شصت و سه در صد گذشته، حال و آینده شناخت'
            },
            {
                id:5,
                question:'لورم ایپسوم متن ساختگی باتولید سادگی نامفهوم ازصنعت چاپ و با استفاده از طراحان گرافیک است؟',
                answer:'چاپگرها و متون بلکه روزنامه و مجله در ستون و سطر آنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزار های کاربردی می باشد. کتاب زیادی در شصت و سه در صد گذشته، حال و آینده شناخت'
            },
        ]
    }
}

export const FOOTER = {
    number1:'01133118994',
    number2:'02171057191',
    text:'مدیزن؛ خدمات پزشکی هوشمند، همیشه در دسترس شما.',
    logo: IMAGES.footer.logo,
    logos:[
        {
            logo:IMAGES.footer.enamad,
            link:''
        },
        {
            logo:IMAGES.footer.ecunion,
            link:''
        },

        
    ]

}
export const DOCTOR_PROFILE = {
    
    about: 'اینجانب دکتر بهادر فرقانی متخصص بیماریهای عفونی و داخلی هستم .سال ۱۳۷۷ دوره عمومی را تمام کردم و پس از آن سال طرح دوره عمومی را گذراندم که دردشت ارژن فارس بود از سال ۱۳۸۰ وارد دوره تخصصی بیماریهای عفونی شدم وسال ۱۳۸۴ از دانشگاه زاهدان در رشته بیماری عفونی فارغ التحصیل شدم . در مدت تحصیل یک سال دورهmph  دانشگاه اصفهان گذراندم که مربوط به بهداشت و درمان است.بورد تخصصی بیماری عفونی دارم.از سال ۱۳۸۴ تا ۱۳۹۷ در استان سیستان و بلوچستان و بیمارستان امام علی چابهار مشغول به کار بودم و همزمان مطب هم چابهار داشتم استخدام رسمی وزارت بهداشت و درمان هستم. عضو نظام پزشکی هستم و بمدت ۴ سال رئیس نظام پزشکی چابهار بودم (۱۳۹۶_۱۳۹۲). سال قبل به تهران دانشگاه ایران منتقل شدم و در حال حاضر در بیمارستان امام حسین(ع)بهارستان مشغول به کار هستم در بخش عفونی.مطب عصر ها دوشنبه و سه شنبه و شنبه فعال است در مطب فعلا ویزیت بیماران عفونی داخلی و مشاوره درمورد بیماریها مقاربتی مشاوره قبل ازدواج انجام میدهم. و حیطه تخصصی کار مربوط به عفونت سیستم مختلف بدن عفونتها پوست هپاتیت ایدز عفونتهای پوستی وتناسلی عفونت مزمن اندام دیابت زخم بستر و عوارض عفونی دیابت شود با توجه به اینکه در بیمارستان دولتی تخت بستری دارم امکان بستری بیماران درموارد لزوم را دارم همچنین موارد ویزیت در منزل را در تهران انجام میدهم(برای عفونتهای ناشی از دیابت و...)',
    services:'در مطب فعلا ویزیت بیماران عفونی داخلی و مشاوره درمورد بیماریها مقاربتی مشاوره قبل ازدواج انجام میدهم. و حیطه تخصصی کار مربوط به عفونت سیستم مختلف بدن عفونتها پوست هپاتیت ایدز عفونتهای پوستی وتناسلی عفونت مزمن اندام دیابت زخم بستر و عوارض عفونی دیابت شود با توجه به اینکه در بیمارستان دولتی تخت بستری دارم امکان بستری بیماران درموارد لزوم را دارم همچنین موارد ویزیت در منزل را در تهران انجام میدهم',
    specialties: [
        'چاپگرها و متونی روزنامه مجله در ستون متن سطری لازم است',
        'چاپگرها و متونی روزنامه مجله در ستون متن سطری لازم است',
        'چاپگرها و متونی روزنامه مجله در ستون متن سطری لازم است',
    ],
    contact:'022-12345678',
    time:'8 الی 14 و 9 الی 21'
}